interface Scripts {
  name: string;
  src: string;
}

export const ScriptStore: Scripts[] = [
  {name: 'ALKMaps', src: 'https://maps.alk.com/api/1.2/alkmaps.js'},
];
